import { NAME } from './constants';
import List from './List.vue';

export const router = {
	path: NAME,
	name: NAME,
	component: List,
};


